// @flow
export const UPDATE_SERVICEWORKER = 'UPDATE_SERVICEWORKER'

export const updateServiceworker = () => ({ type: UPDATE_SERVICEWORKER })
